import moment from 'moment'
export function formatTimeShow (date) {
  if (date) {
    return moment(date).format('YYYY.MM.DD HH:mm:ss')
  } else {
    return '----'
  }
}
const compactFormat = new Intl.NumberFormat('zh-CN', { notation: 'compact' })
export function formatCompact (num) {
  return compactFormat.format(num)
}
